import { EPeriod } from 'shared/types/marketTrends';
import { sendAnalytics } from 'shared/utils/analytics';

const PERIOD_ANALYTICS_MAP: Partial<Record<EPeriod, string>> = {
  [EPeriod.All]: 'alltime',
  [EPeriod.OneYear]: 'year',
  [EPeriod.SixMonths]: 'halfyear',
};

export const trackPeriodFilterChange = (period: EPeriod) =>
  sendAnalytics({
    action: 'Click',
    label: 'dynamic_period',
    page: {
      extra: {
        period: PERIOD_ANALYTICS_MAP[period],
      },
    },
  });
